<app-nav-header></app-nav-header>
<div class="wrapper">
	<div class="main">
		<div id="groupBreakListPage">
			<div class="listArea">
				<div class="listAreaBox">
					<div class="productSection">
						<div class="titleBox">
							<p>團拆商品</p>
						</div>
						<div class="cardGrid">
							<a
								*ngFor="let item of groupBreakList"
								class="productCard"
								[routerLink]="['/', item.productId]"
							>
								<div class="imageBox">
									<img
										[src]="item.image"
										[alt]="item.title"
									/>
								</div>
								<div class="infoBox">
									<p class="productId">
										{{ item.productId }}
										<ng-container *ngIf="item.mode">- {{ item.mode }}</ng-container>
									</p>
									<p class="productTitle">{{ item.title }}</p>
									<p class="productDesc">{{ item.description }}</p>
								</div>
							</a>
							<p
								*ngIf="groupBreakList.length <= 0"
								class="emptyMessage"
							>
								目前尚無上架中的團拆
							</p>
						</div>
					</div>

					<div class="productSection">
						<div class="titleBox">
							<p>周邊商品</p>
						</div>
						<div class="cardGrid">
							<a
								*ngFor="let item of merchList"
								class="productCard"
								[routerLink]="['/', item.productId]"
							>
								<div class="imageBox">
									<img
										[src]="item.image"
										[alt]="item.title"
									/>
								</div>
								<div class="infoBox">
									<p class="productTitle">{{ item.title }}</p>
									<p class="productDesc">{{ item.description }}</p>
								</div>
							</a>
							<p
								*ngIf="merchList.length <= 0"
								class="emptyMessage"
							>
								目前尚無上架中的周邊商品
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<app-footer></app-footer>
